import { District } from '@okapi/graphql/types.generated';
import { Option } from '@okapi/types';

export const getOptions = (districts: Pick<District, 'id' | 'name'>[]): Option[] =>
  districts.map(({ id, name }) => ({
    value: id,
    label: name
  }));
